// 공통 iceServers 설정
export const iceServers = [
  { urls: 'stun:stun.l.google.com:19302' },
  // { urls: 'stun:stun1.l.google.com:19302' },
  // { urls: 'stun:stun2.l.google.com:19302' },
  // { urls: 'stun:stun3.l.google.com:19302' },
  { urls: 'turns:turn.seoultel.co.kr:5349', username: 'sdmgmt', credential: '46#xjstjqjT.com' },
];
